import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OtherService } from '../Service/other.service';
import { GurdServiceService } from '../Service/gurd-service.service';
import { NotificationService } from '../Service/notification.service';
import axios from "src/app/Service/axios";


@Component({

  selector: 'app-added-cars',

  templateUrl: './added-cars.component.html',

  styleUrls: ['./added-cars.component.css']

})

export class AddedCarsComponent implements OnInit {

  lst_NewCar: any[] = [];

  lst_NewCar_Tmp: any[] = [];

  mdl_Search: FormGroup = this.fb.group({

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private fb: FormBuilder,

    private _gurd: GurdServiceService,

    private _other: OtherService,

  ) { }

  ngOnInit(): void {

  }

  async search_NewCar() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('لطفا تاریخ شروع و پایان را مشخص کنید');

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`Mobile_NewAdded_List`, this._other.stringNumberToNumber(this.mdl_Search.value))).data);

    this._other.nonespinner();

    this.lst_NewCar = res;

    this.lst_NewCar_Tmp = res;

  }

  openDetail(strUnitID: number) {

    window.open(`carInfo/${strUnitID}`, "_blank")

  }

  filterResult(strValue: string) {

    if (strValue.length > 1) {

      this.lst_NewCar = this.lst_NewCar_Tmp.filter((el: any) => {

        return el.strSystemUser_strFullName.includes(strValue) ||

          el.strFullName.includes(strValue)

      })

    }

    else if (strValue == '') this.lst_NewCar = this.lst_NewCar_Tmp


  }


}
